import axios from "axios";
import { config } from "../config/environment";

const api = axios.create({
  baseURL: config.api.baseUrl,
  timeout: config.api.timeout,
});

export interface User {
  id: number;
  username: string;
  email: string;
  role: "admin" | "staff";
  isActive: boolean;
}

export interface LoginCredentials {
  email: string;
  password: string;
}

export const login = async (credentials: LoginCredentials): Promise<User> => {
  const response = await api.post("/users/login", credentials);
  const user = response.data;

  // Store user in localStorage
  localStorage.setItem("user", JSON.stringify(user));

  return user;
};

export const logout = (): void => {
  localStorage.removeItem("user");
};

export const getCurrentUser = (): User | null => {
  const userStr = localStorage.getItem("user");
  if (!userStr) return null;

  try {
    return JSON.parse(userStr);
  } catch (error) {
    console.error("Error parsing user from localStorage:", error);
    return null;
  }
};

export const isAuthenticated = (): boolean => {
  return getCurrentUser() !== null;
};
